export default __webpack_public_path__ + "static/media/twitter.f2ce0787.svg";